export default __webpack_public_path__ + "static/media/Entrance.e238ba08.mp3";